import {
  ScheduledNotificationRecipientTypeEnums,
  ScheduledNotificationSubjectTypeEnums,
  ScheduledNotificationTypeEnums,
} from '../components/scheduled-notifications/share-type'
import translate from '../i18n'

export const getSubjectTypeTranslate = (
  subjectType: ScheduledNotificationSubjectTypeEnums,
): string => {
  switch (subjectType) {
    case ScheduledNotificationSubjectTypeEnums.CORPORATE_CREDITS_DISTRIBUTION_SCHEDULE:
      return translate('scheduledNotification.subject.corporateCreditsDistributionSchedule')
  }
  return subjectType
}

export const getRecipientTypeTranslate = (
  recipientType: ScheduledNotificationRecipientTypeEnums,
): string => {
  switch (recipientType) {
    case ScheduledNotificationRecipientTypeEnums.STUDIO:
      return translate('scheduledNotification.recipient.studio')
    case ScheduledNotificationRecipientTypeEnums.USER:
      return translate('scheduledNotification.recipient.user')
    case ScheduledNotificationRecipientTypeEnums.ADMIN:
      return translate('scheduledNotification.recipient.admin')
    case ScheduledNotificationRecipientTypeEnums.CORPORATE_CREDITS_DISTRIBUTION_SCHEDULE_HISTORY:
      return translate(
        'scheduledNotification.recipient.corporateCreditsDistributionScheduleHistory',
      )
  }
  return recipientType
}

export const getNotifyTypeTranslate = (
  notificationType: ScheduledNotificationTypeEnums,
): string => {
  switch (notificationType) {
    case ScheduledNotificationTypeEnums.CORPORATE_DISTRIBUTE_CREDITS:
      return translate('scheduledNotification.notifyType.corporateDistributeCredits')
  }
  return notificationType
}
